import * as Joi from 'joi';
import _ from 'lodash';
import { CLIENT_STATE_KEYS, CLIENT_STATE_VERSIONS, } from '../../client-state-type';
import { ClientStateV2Schema } from '../types/v2';
import { ClientStateV3Class } from '../types/v3';
const upgradeV2dot2ToV3 = (inputClientState, vizModel) => {
    const clientState = inputClientState;
    const chartVizColumnProperties = clientState[CLIENT_STATE_KEYS.columnProperties];
    _.forIn(chartVizColumnProperties, (columnProperties) => {
        delete columnProperties.format;
    });
    _.set(clientState, CLIENT_STATE_KEYS.columnProperties, chartVizColumnProperties);
    _.set(clientState, CLIENT_STATE_KEYS.version, CLIENT_STATE_VERSIONS.V3);
    const clientStateV3 = new ClientStateV3Class();
    _.assign(clientStateV3, clientState);
    return clientStateV3;
};
const upgraderFn = (clientState, vizModel) => {
    Joi.assert(clientState, ClientStateV2Schema);
    const clientStateVersion = _.get(clientState, CLIENT_STATE_KEYS.version);
    if (clientStateVersion !== CLIENT_STATE_VERSIONS.V2dot2) {
        throw new Error(`incompatible client state received in chart upgrade path for v2.2 to v3 with version no:${clientStateVersion}`);
    }
    return upgradeV2dot2ToV3(clientState, vizModel);
};
const testHooks = {
    upgradeV2dot2ToV3,
};
export { upgraderFn, testHooks };
//# sourceMappingURL=v2dot2-to-v3.js.map